/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CompetenceDropdown200,
  GetApiV1CompetenceDropdown401,
  GetApiV1CompetenceDropdown500,
  GetApiV1CompetenceDropdownQueryParams,
  GetApiV1CompetenceDropdownQueryResponse,
} from "../../types/competenceRegistroController/GetApiV1CompetenceDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1CompetenceDropdownQueryParamsSchema = z
  .object({
    ids: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1CompetenceDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CompetenceDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1CompetenceDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CompetenceDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CompetenceDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceDropdown500>;

export const getApiV1CompetenceDropdownQueryResponseSchema = z.lazy(
  () => getApiV1CompetenceDropdown200Schema,
) as unknown as ToZod<GetApiV1CompetenceDropdownQueryResponse>;
